import React, { useState, useEffect } from 'react';
import { postGolfRateMaster } from '../api/paymentAPI';
import * as helper from '../global/helper';
import swal from 'sweetalert2';

const GolfRateTable = (props) => {
    const { ID, expandedMenu, sportID, fetchRateMasterBySportID, rateMaster } = props;

    const rows = [
        { no: 1, Hole:18, UserType: 'Member', Type: 'Weekday' },
        { no: 2, Hole:18, UserType: 'Member', Type: 'Weekends' },
        { no: 3, Hole:9, UserType: 'Member', Type: 'Weekday' },
        { no: 4, Hole:9, UserType: 'Member', Type: 'Weekends' },
        { no: 5, Hole:18, UserType: 'Child', Type: 'Weekday' },
        { no: 6, Hole:18, UserType: 'Child', Type: 'Weekends' },
        { no: 7, Hole:9, UserType: 'Child', Type: 'Weekday' },
        { no: 8, Hole:9, UserType: 'Child', Type: 'Weekends' },
        { no: 9, Hole:18, UserType: 'Guest', Type: 'Weekday' },
        { no: 10, Hole:18, UserType: 'Guest', Type: 'Weekends' },
        { no: 11, Hole:9, UserType: 'Guest', Type: 'Weekday' },
        { no: 12, Hole:9, UserType: 'Guest', Type: 'Weekends' },
        { no: 13, Hole:18, UserType: 'Guest Child', Type: 'Weekday' },
        { no: 14, Hole:18, UserType: 'Guest Child', Type: 'Weekends' },
        { no: 15, Hole:9, UserType: 'Guest Child', Type: 'Weekday' },
        { no: 16, Hole:9, UserType: 'Guest Child', Type: 'Weekends' },
        { no: 17, Hole:18, UserType: 'Visitor', Type: 'Weekday' },
        { no: 18, Hole:18, UserType: 'Visitor', Type: 'Weekends' },
        { no: 19, Hole:9, UserType: 'Visitor', Type: 'Weekday' },
        { no: 20, Hole:9, UserType: 'Visitor', Type: 'Weekends' },
        { no: 21, Hole:18, UserType: 'Visitor Child', Type: 'Weekday' },
        { no: 22, Hole:18, UserType: 'Visitor Child', Type: 'Weekends' },
        { no: 23, Hole:9, UserType: 'Visitor Child', Type: 'Weekday' },
        { no: 24, Hole:9, UserType: 'Visitor Child', Type: 'Weekends' }
    ];
    
    const initialRateMasterDetails = rows.map(row => ({
        SportID: sportID,
        CalenderID: ID,
        UserType: row.UserType,
        Hole: row.Hole,
        Type: row.Type,
        GreenFee: 0,
        Cart: 0,
        Caddy: 0,
        Tax: 0,
        Total: 0,
        Remark: '',
    }));
  
    const [rateMasterList, setRateMasterList] = useState(initialRateMasterDetails);
   
    useEffect(() => {
        if(expandedMenu === ID  && rateMaster.length > 0){
            setRateMasterList(rateMaster);
        }else{
            setRateMasterList(initialRateMasterDetails);
    
        }
    }, [rateMaster, expandedMenu])
  
    const updateRateMaster = (userType, hole, type, field, value) => {
        setRateMasterList((prevDetails) => {
            return prevDetails.map(detail => {
                if (detail.UserType === userType && detail.Hole === hole && detail.Type === type) {
                    const updatedDetail = {
                        ...detail,
                        [field]: value,
                    };
    
                    const greenFee = parseFloat(updatedDetail.GreenFee) || 0;
                    const cart = parseFloat(updatedDetail.Cart) || 0;
                    const caddy = parseFloat(updatedDetail.Caddy) || 0;
    
                    const rate = greenFee + cart + caddy;
                    const tax = rate * 0.18;
                    const total = rate + tax;
    
                    updatedDetail.Tax = Math.round(tax);
                    updatedDetail.Total = Math.round(total);
    
                    return updatedDetail;
                }
                return detail;
            });
        });
    };

    const syncHole18WithHole9 = (list) => {
        return list.map((item) => {
            if (item.Hole == 9) {
                const matRecord = list.find(r => 
                    r.UserType === item.UserType && 
                    r.Hole == 18 && 
                    r.Type === item.Type
                );
                if (matRecord) {
                    return {
                        ...item,
                        GreenFee: matRecord.GreenFee,
                        Cart: matRecord.Cart,
                        Caddy: matRecord.Caddy,
                        Tax: matRecord.Tax,
                        Total: matRecord.Total,
                        Remark: matRecord.Remark,
                    };
                }
            }
            return item;
        });
    };
    
    const handleSave = async() => {
        const btn = $('#btnSave');
        helper.StartProcessing(btn);
    
        try { 
            const syncedRateMasterList = syncHole18WithHole9(rateMasterList);
            await postGolfRateMaster(syncedRateMasterList);
            if (rateMasterList[0].ID) {            
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Master updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,  
                    onOpen: () => swal.hideLoading()                                     
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Master added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()    
                });
                
            }
            fetchRateMasterBySportID();
            helper.StopProcessing(btn);
                    
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    };
  
    return(
        <>
            <div>
                <div id="accordionExample4">
                    <div id={`collapse-${ID}`} className={`collapse ${expandedMenu === ID ? 'show' : ''}`} aria-labelledby={`menuHeading-${ID}`} data-parent="#accordionExample4">
                        <div className="card-body">
                            <div className="kt-widget4">
                                <div className="kt-widget4__item padding-tb5">
                                    <table id="tblGreenFee" className="table table-bordered" style={{ width: '100%', backgroundColor: 'none' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '5%' }}>No</th>
                                                <th style={{ width: '15%' }}>Particular</th>
                                                <th style={{ width: '5%' }}>Holes</th>
                                                <th style={{ width: '10%' }}>Days</th>
                                                <th style={{ width: '10%' }}>Green Fee</th>
                                                <th style={{ width: '10%' }}>Cart</th>
                                                <th style={{ width: '10%' }}>Caddy</th>
                                                <th style={{ width: '10%' }}>Tax</th>
                                                <th style={{ width: '10%' }}>Total</th>
                                                <th style={{ width: '15%' }}>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rateMasterList.length > 0 && rateMasterList.filter((f) => f.Hole !== 9).map((detail, index) => (
                                                <tr key={`${detail.UserType}-${detail.Hole}-${detail.Type}`}>
                                                    <td>{index + 1}</td>
                                                    <td>{detail.UserType}</td>
                                                    <td>{detail.Hole}</td>
                                                    <td>{detail.Type}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control input-sm"
                                                            value={detail.GreenFee || 0}
                                                            onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'GreenFee', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control input-sm"
                                                            value={detail.Cart || 0}
                                                            onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'Cart', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control input-sm"
                                                            value={detail.Caddy || 0}
                                                            onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'Caddy', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control input-sm"
                                                            value={Math.round(detail.Tax) || 0}
                                                            disabled
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control input-sm"
                                                            value={Math.round(detail.Total) || 0}
                                                            disabled
                                                        />
                                                    </td>
                                                    <td>
                                                        <textarea
                                                            className="form-control input-sm"
                                                            style={{ width: '100%', height: '40px' }}
                                                            rows="3"
                                                            value={detail.Remark || ''}
                                                            onChange={(e) => updateRateMaster(detail.UserType, detail.Hole, detail.Type, 'Remark', e.target.value)}
                                                        ></textarea>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="clearfix form-actions">
                                        <button type="button" id="btnSave" name="btnSave" className="btn btn-primary" onClick={handleSave}>
                                            <i className="fa fa-save"></i> Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GolfRateTable;